<template>
    <div class="wrap">
        <div class="hd-bg">
            <div class="header">
                <div class="left"><a href="javascript:;" class="btn return" @click="$router.back()"></a></div>
                <div class="right"><a href="javascript:;" class="btn tel" @click="telConfirm"></a><a href="javascript:;" class="btn user" @click="checkLogined"></a></div>
                <div class="center">资讯</div>
                <!-- <div class="center"><router-link to="/">全部户型</router-link></div> -->
            </div>
        </div>
        <div class="main-wrap">
            <div class="video-wrap" v-if="liveInfo">
                <div class="top">{{liveInfo.live_name}}</div>
                <div class="time">直播预告：{{liveInfo.live_time}}</div>
                <div class="video-btn">开播提醒</div>
            </div>
            <div class="banner" @click="zhibo" v-if="adeInfo">
              
                <img :src="downPath+adeInfo.ade_img" alt="">
            </div>
            <div class="wrap-item">
                 <div class="item" :class="{'active':tabindex==1}" @click="enterlist(newtypeList[0].type,1)">
                    <div class="inner">
                        <div class="top">{{newtypeList[0].typename}}</div>
                        <div class="bottom"></div>
                    </div>
                </div>
                <div class="item" :class="{'active':tabindex==2}" @click="enterlist(newtypeList[1].type,2)">
                    <div class="inner">
                        <div class="top">{{newtypeList[1].typename?newtypeList[1].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[1].typename?newtypeList[1].typename.substring(2,4):''}}</div>
                    </div>
                </div>
                <div class="item" :class="{'active':tabindex==3}" @click="enterlist(newtypeList[2].type,3)">
                    <div class="inner">
                        <div class="top">{{newtypeList[2].typename?newtypeList[2].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[2].typename?newtypeList[2].typename.substring(2,4):''}}</div>
                    </div>
                </div>
                <div class="item" :class="{'active':tabindex==4}" @click="enterlist(newtypeList[3].type,4)">
                    <div class="inner">
                        <div class="top">{{newtypeList[3].typename?newtypeList[3].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[3].typename?newtypeList[3].typename.substring(2,4):''}}</div>
                    </div>
                </div>
               
                
                 <div class="item" :class="{'active':tabindex==5}" @click="enterlist(newtypeList[4].type,5)">
                    <div class="inner">
                        <div class="top">{{newtypeList[4].typename?newtypeList[4].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[1].typename?newtypeList[1].typename.substring(2,4):''}}</div>
                    </div>
                </div>
                 <div class="item" :class="{'active':tabindex==6}" @click="enterlist(newtypeList[5].type,6)">
                    <div class="inner">
                        <div class="top">{{newtypeList[5].typename?newtypeList[5].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[5].typename?newtypeList[5].typename.substring(2,4):''}}</div>
                    </div>
                </div>
            </div>
            <div class="wrap-item b-wrap-item" >
                 <div class="item shendu" :class="{'active':tabindex==7}" @click="enterlist(newtypeList[6].type,7)">
                    <div class="inner">
                        <div class="top">{{newtypeList[6].typename?newtypeList[6].typename.substring(0,2):''}}</div>
                        <div class="bottom"></div>
                    </div>
                </div>
                <div class="item" :class="{'active':tabindex==8}" @click="enterlist(newtypeList[7].type,8)">
                    <div class="inner">
                        <div class="top">{{newtypeList[7].typename?newtypeList[7].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[7].typename?newtypeList[7].typename.substring(2,4):''}}</div>
                    </div>
                </div>
                <div class="item" :class="{'active':tabindex==9}" @click="enterlist(newtypeList[8].type,9)">
                    <div class="inner">
                        <div class="top">{{newtypeList[8].typename?newtypeList[8].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[8].typename?newtypeList[8].typename.substring(2,4):''}}</div>
                    </div>
                </div>
                <div class="item" :class="{'active':tabindex==10}" @click="enterlist(newtypeList[9].type,10)">
                    <div class="inner">
                        <div class="top">{{newtypeList[9].typename?newtypeList[9].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[9].typename?newtypeList[9].typename.substring(2,4):''}}</div>
                    </div>
                </div>
               
                
                 <div class="item" :class="{'active':tabindex==11}" @click="enterlist(newtypeList[10].type,11)">
                    <div class="inner">
                        <div class="top">{{newtypeList[10].typename?newtypeList[10].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[10].typename?newtypeList[10].typename.substring(2,4):''}}</div>
                    </div>
                </div>
                 <div class="item" :class="{'active':tabindex==12}" @click="enterlist(newtypeList[11].type,12)">
                    <div class="inner">
                        <div class="top">{{newtypeList[11].typename?newtypeList[11].typename.substring(0,2):''}}</div>
                        <div class="bottom">{{newtypeList[11].typename?newtypeList[11].typename.substring(2,4):''}}</div>
                    </div>
                </div>
            </div>
             <van-list  v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <div class="news-wrap">
                <div class="news-item" @click="enterdetail(item)" v-for="item in new_list" :key="item.info_id">
                    <div class="left">
                        <div class="head">{{item.title}}</div>
                        <div class="desc">{{item.description}}</div>
                        <div class="tag">
                            <span :key="label" v-for="label in item.label_name">{{label}}</span>
                        </div>
                        <div class="bottom">
                            <div class="b-left">
                                <span>{{item.author}}</span>
                                |
                                <span>{{item.article_source}}</span>
                            </div>
                            <div class="b-right">{{item.create_time | FormatTime}}</div>
                        </div>
                    </div>
                    <div class="right">
                        <van-image alt="" v-lazy :src="item.url">
                            <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                            </template>
                        </van-image>
                    </div>
                </div>
            </div>
             </van-list>
        </div>
       
        <div class="footer">
            <div>
                <div class="footer-tel">客服电话 | 400-0080-960</div>
                <div class="footer-copy">
                    <p>© 2016-2018 选址中国控股有限公司</p>
                    <p>京ICP备16020840号</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Dialog } from 'vant'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { SwipeCell, Toast, List } from 'vant'

    export default {
        name: "alltype",
        data: function () {
            return {
                newtypeList:[{},{},{},{},{},{},{},{},{},{},{},{},{}],
                adeInfo:{},
                page:1,
                nowindex:'top_new',
                loading: false,
                finished: false,
                tabindex:1,
                downPath:'',
                liveInfo:{},
                nindex:1,
                new_list:[],
                sidei:1
            }
        },
        components: {
            Header,
            [Dialog.name]: Dialog,
            [List.name]: List
        },
        mounted(){
            
        },
        created(){
           this.getNav('top_new')
           this.downPath = this.api.downPath;
            this.getList()
        },
         filters: {
            FormatTime (timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                    return Y+M+D
            }
        },
        methods: {
            onLoad: function(){
                setTimeout(()=>{
                    this.getList('top_new')
                }, 500)
            },
            enterdetail(item){
//enterdetail
                this.$router.push({
                    path: '/detailInfoView',
                    query: {
                        id: item.info_id
                    }
                })
            },
            zhibo(){
                window.location.href=this.adeInfo.ade_url
            },
            enterlist(item,val){
                this.page=1
                this.new_list=[]
                this.tabindex=val
                this.nowindex=item
                this.getList(item)
            },
            getNav(){
                var that = this;
                that.api.getNav().then(function(res){
                that.newtypeList=res.newtypeList
                   that.liveInfo=res.liveInfo
                   that.adeInfo=res.adeInfo
                })
            },
             getList(val){
                var that = this;
                that.api.getList({
                    type:that.nowindex,
                    page:that.page,
                    pageSize:10
                }).then(function(res){
                     that.loading = false;
                    that.page++;
                     if (res.new_list.length < 10) {
                        that.finished = true
                    }
                    let arr=res.new_list.map(item=>{
                        item.url=that.downPath+item.thumbnail
                        item.labelarr=item.label_ids.split(',')
                        return item;
                    })
                    that.new_list=that.new_list.concat(arr)
                })
            },
            sidechange(val){
                this.sidei=val
            },
            nindexchange(val){
                this.nindex=val
            },
            checkLogined () {
                var that = this;
                that.api.getUserInfo().then(function(response){
                    if (response.status == 1) {
                        that.$router.push('UserCenter')
                    } else {
                        that.$router.push('Login')
                    }
                })
            },
            telConfirm () {
                Dialog.confirm({
                    title: '400转接',
                    message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:4000080960";
                }).catch(()=>{});
            }
          
          
        }
    }
</script>
<style lang="scss" scoped>
    @import "./common.scss";
    .b-wrap-item{
        padding-bottom:px2rem(6px)
    }
    .wrap-item .active:after{
        position:absolute;
        height:px2rem(4px);
        width:px2rem(4px);
        background:#019bff;
        border-radius: 50%;
        content: "";
        bottom:px2rem(-8px);
    }
    .b-left{
        color:#3c3c3c;
        
    }
    .b-right{
        margin-right:px2rem(10px);
    }
    .news-wrap .bottom{
        font-size:px2rem(8px);
        margin-top:px2rem(4px);
        align-items: center;
        display:flex;
        justify-content: space-between;

    }
    .news-wrap .head{
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .news-wrap .desc{
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .news-wrap .right{
        display:flex;
        align-items: center;
        justify-content: center;
        width:34%;
        height:px2rem(60px);
    }
    .news-wrap img{
        width:100%;
        height:100%;
        display:block;
    }
    .news-wrap .left{
        width:63%;
    }
    .news-wrap .tag{
        padding-left:px2rem(14px);
        margin-top:px2rem(4px);
        height:px2rem(11px);
        display:flex;
        align-items: center;
        background:url(./tagbg.png) no-repeat 0 center;
        background-size:px2rem(11px) auto;
        color:#019bfd;
    }
    .news-wrap .desc{
        font-size:px2rem(9px);
        color:#b5b5b5;
    }
    .news-wrap .head{
        font-size:px2rem(12px);
        padding:px2rem(4px) 0;
        
    }
    .news-item{
        position:relative;
        align-items: center;
        display:flex;
        padding:px2rem(17px) 0 px2rem(17px) 0;
        justify-content: space-between;
        border-bottom:px2rem(1px) solid #f2f2f4;
    }
    .wrap-item .inner{
        position:relative;
        top:px2rem(2px);
    }
    .wrap-item .bottom{
        position:relative;
        top:px2rem(-4px);
    }
    .wrap-item{
        margin-top:px2rem(10px);
        display: flex;
        justify-content: space-around;
    }
     .wrap-item .item:nth-child(1){
        background:url(./newone.png) no-repeat #f95b20 center bottom;
        background-size:100% auto;
    }
    .wrap-item .item:nth-child(1) .top{
        position:relative;
        top:px2rem(-4px)
    }
     .wrap-item .shendu{
        background:url(./deep.png) no-repeat #141757 center bottom!important;
        background-size:100% auto!important;
    }
     .wrap-item .shendu .top{
        position:relative;
        top:px2rem(-4px)
    }
    .wrap-item .item:nth-child(2){
        background:#22ccf0;
    }
    .wrap-item .item:nth-child(3){
        background:#1ad3c3;
    }
    .wrap-item .item:nth-child(4){
        background:#0cd390;
    }
    .wrap-item .item:nth-child(5){
        background:#0fd872;
    }
    .wrap-item .item:nth-child(6){
        background:#6ec833;
    }
    .wrap-item .item{
        position:relative;

        border-radius:px2rem(4px);
        color:#fff;
        display:flex;
        justify-content: center;
        align-items: center;
        height:px2rem(34px);
        width:px2rem(34px);
    }
    .banner img{
        width:100%;
        height:100%;
        display:block;
    }
    .banner{
        margin-top:px2rem(10px);
        border-radius:px2rem(5px);
        height:px2rem(70px);
            }
    .video-wrap .top{
        font-size:px2rem(14px);
        margin-bottom:px2rem(10px)
    }
    .video-btn{
        border-radius:px2rem(3px);
        position:absolute;
        bottom:px2rem(10px);
        right:px2rem(12px);
        display:flex;
        justify-content: center;
        align-items: center;
        background:#019bff;
        text-align:center;
        color:#fff;
        width:px2rem(50px);
        height:px2rem(20px);
    }
    .video-wrap{
        position:relative;
        background:#e9f6fe;
        padding:px2rem(18px) px2rem(14px);
    }
    .main-wrap{
       
        background:#fff;
        padding:px2rem(6px) px2rem(12px);
    }
    .hd-bg {height: 1rem;}

    .header {
        position: fixed;top: 0;left: 0;width: 100%;height: 1rem;z-index: 100;
        background-color: #343434;line-height: 1rem;text-align: center;
    }
    .header .btn {
        display: inline-block;vertical-align: middle;width: .36rem;height: .36rem;margin: 0 .15rem;
        background-repeat: no-repeat;background-position: center center;-webkit-background-size: contain;background-size: contain;
    }
    .header .return {background-image: url('../assets/images/icon-return.png');}
    .header .user {background-image: url('../assets/images/icon-head-user.png');}
    .header .tel {background-image: url('../assets/images/icon-head-tel.png');}
    .header .left {
        position: absolute;top: 0;left: .15rem;
    }
    .header .right {
        position: absolute;top: 0;right: .15rem;
    }
    .header .center {
        position: relative;
        display: inline-block;
        font-size: .36rem;color: #ffffff;
    }
    .header .city {
        position: absolute;left: 100%;top: 50%;margin: -.7em .1rem 0;
        white-space: nowrap;font-size: .6em;line-height: 2;
        padding-right: .2rem;background: url("../assets/images/icon-sel3.png") no-repeat right center;-webkit-background-size: .15rem;background-size: .15rem;
    }
     .footer {
         bottom:0;
        width: 100%; 
        position:absolute;
        background-color: #343434;
        text-align: center;
        height:2rem;
        display:flex;
        align-items: center;
        justify-content: center;
    }
    .footer-tel {
        font-size: .22rem;color: #ffffff;
    }
    .wrap{
        position:relative;
        min-height:100%;
        padding-bottom:2rem;
    }
    .footer-copy {
        font-size: .18rem;color: #ffffff;
    }
    .news-wrap .tag span{
        font-size:px2rem(8px);
        padding:0 px2rem(3px)
    }
</style>